export default "__VITE_ASSET__CAkz$tm$__"